module.exports = __webpack_public_path__ + "static/img/Air freight picture.4b80642.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logistics/Air freight picture.png
// module id = aTwH
// module chunks = 44